import React from 'react';
import clsx from 'clsx';
export const cn = clsx;

export const inputClass = (error = false) =>
  cn(
    'mt-1.5 w-full rounded-lg border bg-white px-3 py-2 text-[13px] text-slate-800 shadow-sm outline-none transition',
    'placeholder:text-slate-400 focus:border-primary-500 focus:ring-2 focus:ring-primary-100',
    'disabled:cursor-not-allowed disabled:bg-slate-50 disabled:text-slate-400',
    error ? 'border-red-400 focus:border-red-500 focus:ring-red-100' : 'border-slate-200',
  );

export const labelClass = 'text-[12px] font-medium text-slate-700';
export const helpClass = 'mt-1 text-[11px] leading-4 text-slate-500';

export const primaryButton =
  'inline-flex h-9 items-center justify-center gap-1.5 rounded-lg bg-primary-600 px-3.5 text-[12px] font-semibold text-white shadow-sm transition hover:bg-primary-700 active:scale-[0.98] disabled:pointer-events-none disabled:opacity-50';

export const secondaryButton =
  'inline-flex h-9 items-center justify-center gap-1.5 rounded-lg border border-slate-200 bg-white px-3 text-[12px] font-medium text-slate-700 shadow-sm transition hover:border-slate-300 hover:bg-slate-50 active:scale-[0.98] disabled:pointer-events-none disabled:opacity-50';

export const subtleButton =
  'inline-flex h-8 items-center justify-center gap-1.5 rounded-lg px-2.5 text-[12px] font-medium text-slate-600 transition hover:bg-slate-100 hover:text-slate-900 disabled:pointer-events-none disabled:opacity-50';

export const iconButton =
  'inline-flex h-8 w-8 items-center justify-center rounded-lg text-slate-400 transition hover:bg-slate-100 hover:text-slate-700 disabled:pointer-events-none disabled:opacity-40';

export const dangerIconButton =
  'inline-flex h-8 w-8 items-center justify-center rounded-lg text-slate-400 transition hover:bg-red-50 hover:text-red-600 disabled:pointer-events-none disabled:opacity-40';

export function Skeleton({ className = '' }: { className?: string }) {
  return <div aria-hidden="true" className={cn('animate-pulse rounded-lg bg-slate-200/80', className)} />;
}

export function PanelHeader({
  eyebrow,
  title,
  description,
  action,
}: {
  eyebrow?: string;
  title: string;
  description?: string;
  action?: React.ReactNode;
}) {
  return (
    <div className="flex items-start justify-between gap-3 border-b border-slate-100 px-4 py-3">
      <div className="min-w-0">
        {eyebrow && <div className="text-[10px] font-semibold uppercase tracking-[0.12em] text-slate-400">{eyebrow}</div>}
        <h2 className="mt-0.5 text-[14px] font-semibold text-slate-900">{title}</h2>
        {description && <p className="mt-0.5 text-[11px] leading-4 text-slate-500">{description}</p>}
      </div>
      {action}
    </div>
  );
}
